import {DeleteUserDocument, DeleteUserInput} from "generated/graphql";
import {useMutation} from "@apollo/client";

export const useDeleteUser = () => {
  const [mutate] = useMutation(DeleteUserDocument);

  return (input: DeleteUserInput) => mutate({ variables: { input } });
}